// Copyright (c) MobiFactory. All rights reserved.
// This source code is the property of MobiFactory. It is exclusively available to customers who have a valid user license.
// See LICENSE.txt file in the project root for full license information.

import backend from "../backend";
import ContactPreview from "../../model/ContactPreview";
import { HttpResult } from "../http";
import NewContact from "../../model/NewContact";
import queryString from "query-string";

const BASE_URI = "/contacts/";

export default {
  /**
   * Gets contacts by emails from backend server
   * @param {string} emails - emails
   * @returns {Promise}  List of ContactPreview
   */
  getContactsByEmails(emails: string[]): Promise<HttpResult<ContactPreview[]>> {
    const url = "/emailmessagecontacts/bymails";
    return backend.post(url, emails);
  },

  /**
   * Creates a new contact on the backend server
   * @param {object} newContact - Contact creation info
   * @returns {string} Contact Id
   */
  createContact(newContact: NewContact) {
    return backend.post(BASE_URI, newContact, {
      showNotificationOnSuccess: true,
    });
  },

  /**
   * Gets the contact reference data
   * @returns {object} - The contact reference data
   */
  getReferenceData() {
    return backend.get("/contactreferencedata");
  },

  /**
   * search contacts from backend server
   * @param {object} filter - search filter
   * @returns {Promise} Paginated list of ContactPreview
   */
  searchContacts(filter: any) {
    const url = BASE_URI + "?" + queryString.stringify(filter);
    return backend.get(url);
  },
};
